import React from 'react';
import moment from 'moment';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import Select from 'react-select';

import {
  FilterFormStyled,
  FilterRow,
  FilterColumn,
} from '../../css/styles/filter';
import { SelectStyled } from '../../css/styles/select';
import { ErrorSharp } from '@material-ui/icons';

const handleValidate = ({ equipment, employee }) => {
  const errors = {};
  if (!equipment) {
    errors.equipment = 'OBRIGATÓRIO';
  }

  return errors;
};

const handleSubmit = props => async (values, { setSubmitting }) => {
  const filters = {
    equipment_uuid: values.equipment?.uuid || null,
  };
  await props.onList(filters);
  setSubmitting(false);
};

const EquipmentFilterForm = props => {
  const { onList, equipmentsOptions } = props;

  return (
    <Formik
      enableReinitialize={false}
      initialValues={{
        equipment: null,
        employee: null,
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        errors,
        touched,
        dirty,
        setFieldValue,
        handleChange,
        handleBlur,
        handleReset,
        isSubmitting,
      }) => (
        <FilterFormStyled>
          <h1>FILTROS</h1>

          <ul>
            <FilterRow>
              <FilterColumn>
                <strong>VEÍCULOS:</strong>
                <Select
                  styles={SelectStyled}
                  id="equipment"
                  value={values.equipment}
                  placeholder="Selecione um veículo"
                  onChange={selectedOption =>
                    setFieldValue('equipment', selectedOption)
                  }
                  isSearchable
                  options={equipmentsOptions}
                  getOptionLabel={item => item.code}
                  getOptionValue={item => item.uuid}
                  name="equipment"
                  isLoading={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando veículos'}
                  noOptionsMessage={() => 'Não há veículos cadastrados'}
                />

                {errors.equipment && touched.equipment && (
                  <span>{errors.equipment}</span>
                )}
              </FilterColumn>
            </FilterRow>
            <FilterRow>
              <div className="buttons-container">
                <button type="submit" disabled={isSubmitting}>
                  BUSCAR
                </button>

                <button
                  type="button"
                  onClick={e => {
                    onList();
                    handleReset();
                  }}
                  disabled={isSubmitting || !dirty}
                >
                  RESET
                </button>
              </div>
            </FilterRow>
          </ul>
        </FilterFormStyled>
      )}
    </Formik>
  );
};

EquipmentFilterForm.propTypes = {
  equipments: PropTypes.arrayOf(PropTypes.shape(PropTypes.string)),
};

EquipmentFilterForm.defaultProps = {
  equipments: [],
};

export default EquipmentFilterForm;

